import {SharedModule} from '../core/shared.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {NgxPaginationModule} from 'ngx-pagination';
import {TrimValueAccessorModule} from 'ng-trim-value-accessor';
import {FormService} from '../core/services/form.service';
import {FormShowComponent} from './form-show/form-show.component';
import {InviteShowComponent} from './invite-show/invite-show.component';
import {FormInviteesListComponent} from './form-invitees-list/form-invitees-list.component';
import {CreateRedirectedFormInviteesComponent} from './create-redirected-form-invitees/create-redirected-form-invitees.component';
import {ReverformService} from '../core/services/reverform.service';
import {RevertFormComponent} from './revert-form/revert-form.component';
import {SignaturePadModule} from 'angular2-signaturepad';
import { InviteFollowUpModalComponent } from './invite-follow-up-modal/invite-follow-up-modal.component';
import { ConsentFormComponent } from './consent-form/consent-form.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    NgxPaginationModule,
    TrimValueAccessorModule,
    ReactiveFormsModule,
    SignaturePadModule
  ],
  declarations: [
    FormShowComponent,
    InviteShowComponent,
    FormInviteesListComponent,
    CreateRedirectedFormInviteesComponent,
    RevertFormComponent,
    InviteFollowUpModalComponent,
    ConsentFormComponent,
  ],
  providers: [
    FormService,
    ReverformService,
  ],

})
export class FormModule {
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/form/form.module.ts